import { getReducerErrorMessage } from 'src/utils/helpers'

const initialState = {
  loading: false,
  drivers: [],
  driver: null,
  driversLicenseFile: null,
  deleteDriverLicenseResponse: null,
  stepCompleted: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'GET_DRIVERS': {
      return {
        ...state,
        loading: true,
      }
    }

    case 'GET_DRIVERS_COMMIT': {
      return {
        ...state,
        loading: false,
        drivers: action.payload.drivers,
      }
    }

    case 'SET_DRIVER': {
      return {
        ...state,
        driver: action.payload.driver,
        stepCompleted: true,
      }
    }

    case 'CLAIMS_DRIVERS_LICENSE_ADD': {
      return {
        ...state,
        driversLicenseFile: action.payload.file || null,
      }
    }

    case 'CLAIMS_DRIVERS_LICENSE_REMOVE': {
      return {
        ...state,
        deleteDriverLicenseResponse: {},
      }
    }
    case 'CLAIMS_DRIVERS_LICENSE_REMOVE_COMMIT': {
      return {
        ...state,
        deleteDriverLicenseResponse: {
          success: true,
        },
      }
    }
    case 'CLAIMS_DRIVERS_LICENSE_REMOVE_ROLLBACK': {
      const isFileNotFound =
        action.payload &&
        action.payload.response &&
        action.payload.response.status &&
        action.payload.response.status === 404

      return {
        ...state,
        // If we got response that file is not found, we can clear it from redux state
        driversLicenseFile: isFileNotFound ? null : state.driversLicenseFile,
        deleteDriverLicenseResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'CLAIMS_DRIVERS_LICENSE_CLEAR': {
      return {
        ...state,
        driversLicenseFile: null,
      }
    }

    default: {
      return state
    }
  }
}
